import { POSTAL_MAIL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
import { ACTIVITY_FILTERS } from '../../permissions/gates';
const PostalMail = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: isUngated => isUngated(ACTIVITY_FILTERS),
  objectTypeId: POSTAL_MAIL_TYPE_ID,
  referenceObjectType: 'POSTAL_MAIL_PROPERTIES'
});
export default PostalMail;